module.exports = __webpack_public_path__ + "static/media/gabriel_what.77cc3445.mp3";